import { render, staticRenderFns } from "./TextCopy.vue?vue&type=template&id=eb4dd5a2&"
import script from "./TextCopy.vue?vue&type=script&lang=js&"
export * from "./TextCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports